(ns ui.view.card.attachments.event
  (:require
   [re-frame.core :as rf]
   [cljs.core.async :as async]
   [potpuri.core :as p]
   [ui.view.card.attachments.model :as model]
   [ui.view.card.event :as common-event]
   [ui.view.card.model :as common-model]
   [frontend.actions.attachment :as attachment-actions]
   [frontend.actions.common :as common-actions]
   [oops.core :as oops]

   [frontend.utils :as fu]
   [ui.cofx.response :as response-cofx]))

(def std-intercept [rf/trim-v])

;; TODO: Implement these so do not use the frontend state
;; Maybe some generic attachment related namespace in ui/..
(rf/reg-fx
 ::upload-attachment
 (fn [{:keys [file ctx]}]
   (let [filename (oops/oget file "name")
         content-type (oops/oget file "type")
         attachment {:filename    filename
                     :description nil
                     :file        file
                     :target      (:entity-id ctx)}
         prog-channel (async/chan)
         token-success! (fn [token]
                          (rf/dispatch [::add-upload-in-progress ctx {:token token
                                                                      :filename filename
                                                                      :content-type content-type
                                                                      :started-at (js/Date.now)}])
                          (attachment-actions/*=>add-attachment
                           {:multipart-params (assoc attachment :token token)
                            :progress         prog-channel}
                           (fn [_resp]
                             (rf/dispatch-sync [::set-upload-progress ctx {:token token
                                                                           :progress 100}])
                             (js/setTimeout
                              #(rf/dispatch [::refetch-data ctx token])
                              50))
                           (fn [e]
                             (js/console.log "Error in uploading attachment" e))))]
     (common-actions/*<-create-op-token nil
                                        token-success!
                                        (fn [e]
                                               ;;TODO show error-bar
                                          (js/console.log "token error " e))))))

(rf/reg-fx
 ::delete-attachment
 (fn
   [{:keys [target-id attachment-id on-success]}]
   (attachment-actions/*<-remove-attachment
    {:target-id target-id :attachment-id attachment-id}
    (fn [_resp]
      (rf/dispatch on-success))
    (fn [e]
      (js/console.log "Delete attachment error " e)))))

(rf/reg-event-fx
 ::set-upload-progress
 [std-intercept
  response-cofx/stale-response?]
 (fn [{:keys [db stale-response?]} [{:keys [card-state-path]} {:keys [token progress]}]]
   (when-not stale-response?
     {:db (assoc-in db (model/upload-in-progress-progress-full-path card-state-path token)
                    progress)})))

(rf/reg-event-fx
 ::add-upload-in-progress
 [std-intercept
  response-cofx/stale-response?]
 (fn [{:keys [db stale-response?]}
      [{:keys [card-state-path] :as _ctx} {:keys [token filename content-type started-at]}]]
   (when-not stale-response?
     {:db (assoc-in db (model/upload-in-progress-full-path card-state-path token)
                    {:filename filename
                     :content-type content-type
                     :progress 3
                     :started-at started-at})})))

(rf/reg-event-fx
 ::upload-files
 std-intercept
 (fn [_ [ctx files]]
   (let [file-count (oops/oget files "length")
         fx (->> (range file-count)
                 (mapv (fn [idx]
                         (let [file (aget files idx)]
                           [::upload-attachment {:file file
                                                 :ctx ctx}]))))]
     {:fx fx})))

(rf/reg-event-fx
 ::delete-attachment
 std-intercept
 (fn [_ [{:keys [entity-id] :as ctx} attachment-id]]
   {::delete-attachment {:target-id entity-id
                         :attachment-id attachment-id
                         :on-success [::refetch-data ctx]}}))

(rf/reg-event-fx
 ::set-folder-expanded
 std-intercept
 (fn [{:keys [db]} [{:keys [card-state-path]} {:keys [folder-name expanded?]}]]
   {:db (assoc-in db (model/folder-expanded-full-path card-state-path folder-name) expanded?)}))

;; TODO: add these events and fx to some common ui namespace?
(rf/reg-fx
 ::open-attachment
 (fn [attachment-id]
   (fu/open-attachment! attachment-id)))

(rf/reg-fx
 ::download-attachment
 (fn [attachment-id]
   (fu/download-attachment! attachment-id)))

(rf/reg-event-fx
 ::open-attachment
 std-intercept
 (fn [_ [attachment-id]]
   {::open-attachment attachment-id}))

(rf/reg-event-fx
 ::download-attachment
 std-intercept
 (fn [_ [attachment-id]]
   {::download-attachment attachment-id}))

(rf/reg-event-fx
 ::refetch-data-success
 [std-intercept
  response-cofx/stale-response?]
 (fn [{:keys [db stale-response?]}
      [{:keys [card-state-path] :as _ctx}
       attachment-upload-token
       {:keys [body] :as _resp}]]
   (when-not stale-response?
     (let [entities (-> body :data :entities)
           entities-by-id (p/index-by :db/id entities)]
       {:db (cond-> db
              true
              (common-model/reset-entities card-state-path entities-by-id)

              attachment-upload-token
              (p/dissoc-in (model/upload-in-progress-full-path card-state-path attachment-upload-token)))}))))

(rf/reg-event-fx
 ::refetch-data
 std-intercept
 (fn [_cofx [ctx attachment-upload-token]]
   (let [event (common-event/create-fetch-card-data-event
                (assoc ctx :on-success [::refetch-data-success ctx attachment-upload-token]))]
     {:fx [[:dispatch event]]})))
